module.exports = __webpack_public_path__ + "static/media/SM-MT-TRIAL1-if-wrong.28937787.mp3";